export default __webpack_public_path__ + "static/media/aeo.bca65a93.png";